import { TopConfig } from '../context/ConfigContext';

export const getConsentServiceRequestConfig = (topConfig: TopConfig, consentTypeId: string) => {
    const { consent: consentServiceConfig } = topConfig.services;
    const { url } = consentServiceConfig;

    if (!url) {
        throw new Error('Consent service: Url not defined');
    }

    return {
        ...consentServiceConfig,
        url: url + consentTypeId
    };
};
